import {action, observable} from "mobx";
import {IApiClient} from "../common/api.client";
import {TrainingContent, TrainingContentFilters} from "../common/webapicall";

export class TrainingContentStore {
	constructor(private apiClient: IApiClient) {}

	@observable questionnaireType: string = "";
	@observable trainings: TrainingContent[] = [];
	@observable currentPage: number = 1;
	@observable hasNext: boolean = false;
	@observable isTrainingContentsLoading: boolean = true;
	@observable isSeeMoreLoading: boolean = false;

	@observable filters: TrainingContentFilters = null;
	@observable selectedTaxonomy: string = "";
	@observable selectedMediaType: string = "";
	@observable showAll: boolean = false;

	@action
	async getTrainingContentFilters() {
		const res = await this.apiClient.trainingContentClient.getTrainingContentFilters();
		this.filters = res;
	}

	@action
	async getInitialTrainingContents(questionnaireType: string) {
		if (this.currentPage !== 1) {
			return;
		}

		this.isTrainingContentsLoading = true;
		this.questionnaireType = questionnaireType;
		const response = await this.apiClient.trainingContentClient.getTrainingContentRecommendations(questionnaireType, this.selectedTaxonomy, this.selectedMediaType, this.showAll, 1, null);
		this.trainings = response.trainingContents;
		this.currentPage = 1;
		this.hasNext = response.hasNextPage;
		this.isTrainingContentsLoading = false;
	}

	@action
	async getNextPageOfTrainingContents() {
		if (!this.hasNext || !this.questionnaireType) {
			return;
		}

		this.isSeeMoreLoading = true;
		const nextPage = this.currentPage + 1;
		const response = await this.apiClient.trainingContentClient.getTrainingContentRecommendations(
			this.questionnaireType,
			this.selectedTaxonomy,
			this.selectedMediaType,
			this.showAll,
			nextPage,
			null,
		);
		this.trainings = [...this.trainings, ...response.trainingContents];
		this.currentPage = response.currentPage;
		this.hasNext = response.hasNextPage;
		this.isSeeMoreLoading = false;
	}

	@action
	async toggleShowAll() {
		if (!this.questionnaireType) {
			return null;
		}

		this.showAll = !this.showAll;
		this.selectedTaxonomy = null;
		this.selectedMediaType = null;
		this.clearTrainingContents();
		await this.getInitialTrainingContents(this.questionnaireType);
	}

	@action
	async onChangeTaxonomy(taxonomyId: string) {
		if (!this.questionnaireType) {
			return null;
		}

		this.selectedTaxonomy = taxonomyId;
		this.showAll = false;
		this.clearTrainingContents();
		await this.getInitialTrainingContents(this.questionnaireType);
	}

	@action
	async onChangeMediaType(mediaType: string) {
		if (!this.questionnaireType) {
			return null;
		}

		this.selectedMediaType = mediaType;
		this.showAll = false;
		this.clearTrainingContents();
		await this.getInitialTrainingContents(this.questionnaireType);
	}

	@action
	clearTrainingContents() {
		this.hasNext = false;
		this.currentPage = 1;
		this.trainings = [];
	}
}
